module.exports = __webpack_public_path__ + "static/img/joinBanner5.ea4bd7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/joinBanner5.jpg
// module id = RkCb
// module chunks = 0